export default __webpack_public_path__ + "1f45d461123dd7d58c2547317d406506.svg";